import { useSelector, useDispatch } from 'react-redux';
import { useCallback, useMemo } from 'react';
import { setSelectedProduct } from '../data/guaranteePurchases/actions';
import {
  PRODUCT_FAMILY_SA,
  PRODUCT_FAMILY_ALL,
} from '../constants/productFamily';
import useFeatureFlag from './useFeatureFlag';
import { DB_GUARANTEES_V2 } from '../constants/featureFlags';

const selectGuaranteePurchases = state => state.data.guaranteePurchases;

export const useGuaranteeProduct = () => {
  const { selectedProduct } = useSelector(selectGuaranteePurchases);
  const dispatch = useDispatch();
  const setProduct = useCallback(
    productId => {
      dispatch(setSelectedProduct(productId));
    },
    [dispatch]
  );
  return [selectedProduct, setProduct];
};

export const useGuaranteeTheme = () => {
  const [selectedProduct] = useGuaranteeProduct();
  const [isGuaranteesV2Enabled] = useFeatureFlag(DB_GUARANTEES_V2);

  const themeClass = useMemo(() => {
    if (!isGuaranteesV2Enabled) return '';

    let specific = 'theme-blue';
    if (selectedProduct === PRODUCT_FAMILY_SA) specific = 'theme-green';
    else if (selectedProduct === PRODUCT_FAMILY_ALL) specific = 'theme-graphite';

    return `theme ${specific}`;
  }, [selectedProduct, isGuaranteesV2Enabled]);

  return themeClass;
};
